import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { PerfilService } from 'src/app/service/perfil.service';
import { TarjetasService } from 'src/app/service/tarjetas.service';


interface validaAMInt {
  apellidos: string
  correo: string
  descTipoTarjeta: string
  descripcion: string
  estadoMA: string
  mensaje: string
  nombres: string
  numABT: string
  numeroExterno: string
  numeroInterno: string
  resultado: string
  rut: string
  tecnologia: string
  tipotarjeta: string
  uidtarjeta: string
  uuidMovil: string
}

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
})
export class AsideComponent implements OnInit {
  @Output() loaded = new EventEmitter();
  @Output() solici = new EventEmitter();
  @Input() getData: any
  loading: boolean = true;

  nombre: string = '';
  cards: { cards: any[] } = { cards: [] };
  dataRes: any;
  ra: any;
  mandatos: any;
  cardSelected: any;
  session: any;
  standby: boolean = false;
  modalError: string = ''
  confirmDel: boolean = false;
  numTarjeta: string = '';
  loaderBtn: boolean = false;


  formNewCard = new FormGroup({
    numTar: new FormControl('', Validators.required),
    nombre: new FormControl('', Validators.required)
  })

  constructor(
    private perfil: PerfilService,
    private route: Router,
    private tarjetas: TarjetasService
  ) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    if (!localStorage.hasOwnProperty('nombre')) {
      this.loadPerfil()
    } else {
      this.nombre = localStorage.getItem('nombre');
    }


    this.tarjetas.currentTarjeta.subscribe(res => {
      let cards = res
      if (cards.cards?.length > 0) {

        this.cards = cards
        this.initData()
      } else {
        setTimeout(() => {

          this.loading = false;
        }, 1000)
      }

    })
    this.getCards()

  }

  getSaldo(card) {
    let date = new Date()
    let dateFormat = `${date.getFullYear()}/${("0" + date.getMonth()).slice(-2)}/${("0" + date.getDay()).slice(-2)}`;

    this.tarjetas.validacionMA(card.numTarjeta).subscribe(
      res => {
        const respuesta: validaAMInt = this.formatData(res);
        let json = {
          "tipoConsulta": 2,
          "numExterno": card.numTarjeta,
          "numInterno": respuesta.numeroExterno,
          "numeroDias": 10,
          "nivelConsulta": 2
        }
        this.tarjetas.getTransaccionesAbt(json).pipe(take(1)).subscribe(
          res => {
            card.saldo = res.estado == -120 ? 0 : res.saldo
          }
        )
      }
    )
  }

  ngOnInit(): void {

  }

  getCards() {
    let json = {
      KSI: this.session.ksi,
      idUsuarioWeb: this.session.idUsuario
    }
    this.tarjetas.getCards(json).subscribe(
      res => {
        const cards = res.resumenCols
        cards.forEach(this.getSaldo.bind(this));
        this.tarjetas.addCards(cards);
      }
    )
  }

  loadPerfil() {
    let json = {
      KSI: this.session.ksi,
      idUsuarioWeb: this.session.idUsuario
    }
    this.perfil.loadUser(json).subscribe(res => {
      this.nombre = res.nombres;
      localStorage.setItem('nombre', this.nombre);
    })
  }

  initData() {
    this.cards.cards = this.tarjetasOrdenadas();
    if (!this.standby) {
      this.standby = true;
      this.dataResumen(0);
    }
  }

  openModalDel(num) {
    this.confirmDel = true;
    this.modalError = '';
    this.numTarjeta = num
  }

  delete() {
    this.loaderBtn = true;
    let json = {
      KSI: this.session.ksi,
      numTarjeta: this.cardSelected,
      idUsuarioWeb: this.session.idUsuario,
      dni: this.session.dpi,
    }
    this.tarjetas.deleteCard(json).subscribe(res => {

      if (res.numError == 0) {
        this.loaderBtn = false
        this.closeModal();
        this.getCards();

      } else {
        this.loaderBtn = false
        this.modalError = res.msjError
      }
    }, () => {
      this.loading = false;
      this.modalError = "Error al desafiliar tarjeta. Inténtelo más tarde.";
    })
  }

  dataResumen(index) {
    let card = this.cards.cards[index];

    this.tarjetas.validacionMA(card.numTarjeta).subscribe(
      res => {
        let respuesta: validaAMInt = this.formatData(res);
        this.dataRes = {
          card,
          numInterno: res
        }
        localStorage.setItem('numInt', respuesta.numeroInterno);
        this.cardSelected = this.cards.cards[index].numTarjeta;
        this.cards = this.cards;
        this.tarjetas.selectCard(this.cardSelected);
        this.loaded.emit(this.dataRes);
        this.standby = false;
        this.loading = false;
      })


  }

  tarjetasOrdenadas() {
    const objetoSeleccionado = this.cards.cards.find(obj => obj.indFavorito === 'S');
    const index = this.cards.cards.indexOf(objetoSeleccionado);
    let listCards = this.cards.cards;
    if (index !== -1) {
      listCards.splice(index, 1);
      listCards.unshift(objetoSeleccionado);
    }

    return listCards
  }

  formatData(data): validaAMInt {
    let value = "0"
    if (data != undefined) {
      const match = data.split(',');
      let item = match[9];
      item = item.split(':');
      value = item[1];
      value = value.replace('"', '');

    }
    let dataParse = JSON.parse(data);
    dataParse.numeroInterno = value;
    return dataParse;

  }


  sendSolici() {
    this.solici.emit(true);
  }

  trackById(item: any) {
    return (item.numTarjeta);
  }

  addNewCard() {
    this.loading = true
    this.modalError = ''
    const nTarjeta = this.formNewCard.get('numTar').value
    const nomTarjeta = this.formNewCard.get('nombre').value

    let json = {
      KSI: this.session.ksi,
      idUsuarioWeb: this.session.idUsuario,
      indFavorita: "N",
      numTarjeta: nTarjeta,
      etiqueta: nomTarjeta
    }
    let jsons = {
      KSI: this.session.ksi,
      idUsuarioWeb: this.session.idUsuario,
    }

    this.tarjetas.newCard(json).subscribe(res => {
      if (res.estado == 0) {
        this.tarjetas.getCards(jsons).subscribe(res => {
          this.tarjetas.addCards(res.resumenCols);
          this.loading = false;
        })
      } else if (res.estado == 500) {
        this.loading = false;
        this.modalError = "Medio de acceso ya se encuentra afiliado al usuario"
      } else {
        this.loading = false;
        this.modalError = res.msjError
      }
    }, () => {
      this.loading = false;
      this.modalError = "Error al afiliar medio de acceso. Inténtelo más tarde.";
    })


    this.tarjetas.validacionMA(nTarjeta).subscribe(

      res => {
        let response = JSON.parse(res)
        if (response.resultado == 0) {
          let json = {
            KSI: this.session.ksi,
            idUsuarioWeb: this.session.idUsuario,
            indFavorita: "N",
            numTarjeta: nTarjeta,
            etiqueta: nomTarjeta
          }
          let jsons = {
            KSI: this.session.ksi,
            idUsuarioWeb: this.session.idUsuario,
          }

          this.tarjetas.newCard(json).subscribe(res => {
            if (res.estado == 0) {
              this.tarjetas.getCards(jsons).subscribe(res => {
                this.tarjetas.addCards(res.resumenCols);
                this.loading = false;
              })
            } else if (res.estado == 500) {
              this.loading = false;
              this.modalError = "Medio de acceso ya se encuentra afiliado al usuario"
            } else {
              this.loading = false;
              this.modalError = res.msjError
            }
          }, () => {
            this.loading = false;
            this.modalError = "Error al afiliar medio de acceso. Inténtelo más tarde.";
          })

        } else {
          this.loading = false;
          this.modalError = "Medio de acceso inválido"
        }

      });
  }

  closeSession() {
    localStorage.clear()
    this.route.navigate(['/'])
  }

  closeModal() {

    this.confirmDel = false;
  }

  onlyNumber($event) {
    let key = $event.charCode;
    if (key <= 57 && key >= 48) {
      return true;
    } else {
      return false
    }
  }
}
